import React from 'react';
import styled from '@emotion/styled';

import theme from '../../theme';
import { MAX_WIDTH_FORM_COMPONENT, MAX_MOBILE_WIDTH_FORM_COMPONENT } from '../../utils/form';

export type LinkToPageProps = {
  linkLabel?: string;
  url?: string;
};
const LinkContainer = styled.div`
  white-space: pre-wrap;
  word-wrap: break-word;
  max-width: ${MAX_WIDTH_FORM_COMPONENT}px;
  @media (max-width: ${theme.screenLgMax}) {
    max-width: ${MAX_MOBILE_WIDTH_FORM_COMPONENT}px;
  }
`;
const Link = styled.a`
  &:link {
    font-size: 16px;
    font-weight: normal;
    line-height: 1.5px;
    color: ${theme.colorsSecondaryBlue};
    text-decoration: underline;
  }
  &:visited {
    color: ${theme.colorsVisitedLinks};
  }
  &:hover {
    font-weight: bold;
  }
`;

const LinkToPage = React.memo(function LinkToPage({ linkLabel, url, ...props }: LinkToPageProps) {
  return (
    <LinkContainer>
      <Link href={url} target="_blank" rel="noopener noreferrer" {...props}>
        {linkLabel}
      </Link>
    </LinkContainer>
  );
});

export default LinkToPage;
